var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "FormulateInput",
            _vm._b(
              {
                ref: "managementAccountLabel",
                class: _vm.showLabel && _vm.required ? "required" : "",
                attrs: {
                  type: "label",
                  label: _vm.showLabel ? _vm.label : "",
                  validation: _vm.required ? "required" : "",
                  options: _vm.options,
                  icons: _vm.icons,
                  icon: !_vm.isReadOnly ? "pencil" : null,
                  "icon-title": _vm.$t("Selecionar Conta Gerencial"),
                },
                on: {
                  edit: function ($event) {
                    _vm.showModal = true
                  },
                  clean: _vm.cleanSelection,
                },
                model: {
                  value: _vm.contentLabel,
                  callback: function ($$v) {
                    _vm.contentLabel = $$v
                  },
                  expression: "contentLabel",
                },
              },
              "FormulateInput",
              _vm.$attrs,
              false
            )
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modal",
          staticStyle: { height: "100%" },
          attrs: {
            id: "modal-management-account",
            "no-close-on-backdrop": "",
            size: "md",
            centered: "",
            scrollable: "",
            "ok-title": _vm.$t("Confirmar"),
            "cancel-title": _vm.$t("Cancelar"),
          },
          on: { ok: _vm.confirm },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _c("p", { staticClass: "h4" }, [
                    _vm._v(" " + _vm._s(_vm.$t("Contas Gerenciais")) + " "),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showModal,
            callback: function ($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      name: "filter",
                      type: "text",
                      placeholder: _vm.$t("Filtrar"),
                    },
                    model: {
                      value: _vm.filter,
                      callback: function ($$v) {
                        _vm.filter = $$v
                      },
                      expression: "filter",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("tree", {
                    ref: "treeView",
                    attrs: {
                      data: _vm.treeData,
                      options: _vm.treeOptions,
                      filter: _vm.filter,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var node = ref.node
                          return _c(
                            "span",
                            { staticClass: "tree-text" },
                            [
                              !node.hasChildren()
                                ? [
                                    _c("i", {
                                      staticClass: "ion-android-star",
                                    }),
                                    _c("span", [_vm._v(_vm._s(node.text))]),
                                    node.data.description
                                      ? _c("e-instructions", {
                                          staticClass: "ml-1",
                                          attrs: {
                                            id: node.data.id,
                                            instruction: node.data.description,
                                            title: _vm.$t("Descrição"),
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                : [
                                    _c("i", {
                                      class: [
                                        node.expanded()
                                          ? "ion-android-folder-open"
                                          : "ion-android-folder",
                                      ],
                                    }),
                                    _vm._v(" " + _vm._s(node.text) + " "),
                                  ],
                            ],
                            2
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }